import { __ } from "@wordpress/i18n";

const register = () => {
  const options = document.querySelectorAll(".wlc-registration__option");
  let form = document.querySelector(".wlc-registration__form");
  const whyWeAsk = document.querySelector("#why-we-ask");
  const radios = document.querySelectorAll("[name=wlc-payer]");
  const optionLekarz = document.querySelector("[data-lekarz]");
  const optionPielegniarka = document.querySelector("[data-pielegniarka]");
  const optionFarmaceuta = document.querySelector("[data-farmaceuta]");

  if (!form) {
    form = document.querySelector(".wlc-my-account__form");
  }

  if (!options.length || !form || !whyWeAsk || !radios || !optionLekarz || !optionFarmaceuta || !optionPielegniarka) return;

  form.reset();

  optionLekarz.addEventListener("click", () => {
    const pwz = document.querySelector(".pwz");
    pwz.setAttribute("title", __("Numer PWZ", "spf"));
    //pwz.querySelector("input").value = "";

    const err = document.querySelector(".pwz_val");
    err?.remove();
  });

  optionPielegniarka.addEventListener("click", () => {
    const pwz = document.querySelector(".pwz");
    pwz.setAttribute("title", __("Numer PWZ", "spf"));
    //pwz.querySelector("input").value = "";

    const err = document.querySelector(".pwz_val");
    err?.remove();
  });

  optionFarmaceuta.addEventListener("click", () => {
    const pwz = document.querySelector(".pwz");
    pwz.setAttribute("title", __("Numer PWZF", "spf"));
    //pwz.querySelector("input").value = "";

    const err = document.querySelector(".pwz_val");
    err?.remove();
  });

  options.forEach((option) => {
    option.addEventListener("click", () => {
      options.forEach((option) => {
        option.classList.remove("active");
      });
      option.classList.add("active");

      const value = option.querySelector("input").value;

      document.querySelector(".pwz").classList.toggle("hidden", "lekarz" !== value && "farmaceuta" !== value && "pielegniarka" !== value);
    });
  });

  whyWeAsk.addEventListener("click", (e) => {
    e.preventDefault();
    const popup = document.querySelector(".wlc-registration__popup-message");
    if (!popup) return;
    popup.classList.toggle("popup-hidden");
  });

  radios.forEach((radio) => {
    radio.addEventListener("change", (e) => {
      const target = e.target;
      const companyContainer = document.querySelector(".wlc-registration-wc__company");

      companyContainer.classList.toggle("hide", "private" === target.value);
    });
  });
};
export { register };
